<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Select All Locations Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5">
      {{ siteText.ui.selectAllLocationsPageHeader }}
    </h2>
    <p class="text-h8 font-weight-bold">
      {{ siteText.ui.selectAllLocationsPageSubHeader }}
    </p>
    <v-card>
      <v-card-text>
      <strong>  {{ siteText.ui.selectAllLocationsLocations }} </strong>
      </v-card-text>
      <v-card-text class="centerContainer">
        <v-row>
          <v-select
            :label="siteText.ui.selectAllLocationsSelectLocation"
            filled
            :items="locations"
            item-text="Name"
            v-model="location"
            @change="locationChange"
            dense
            return-object
          ></v-select>
        </v-row>
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-left pt-4">
      <v-layout row wrap>
      <v-flex md3>
      <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        @click="back()"
        ><v-icon>mdi-arrow-left</v-icon>
        {{ siteText.ui.selectAllLocationsBack }}
      </v-btn>
      </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SelectAllLocationsPage',
  data: () => ({
   locations: [],
    location: '',
  }),
  methods: {
    ...mapActions(['getLocationsWithServiceType']),
    ...mapActions(['selectLocation']),
    ...mapActions({
      navToSelectDateTimePageAction: 'navToSelectDateTimePage',
    }),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      if (this.navToSelectAllLocationsPage === 'SelectLocationPage') {
        this.$emit('navigateTo', 'SelectLocationPage', { 
          pageName:'Select Reservation Location'
        });
      } else if (this.navToSelectAllLocationsPage === 'SearchLocationPage') {
        this.$emit('navigateTo', 'SearchLocationPage', { 
          pageName:'Choose a Reservation Location'
        });
      }
    },
    locationChange() {
      console.log(this.location);
      this.selectLocation(this.location);
      this.navToSelectDateTimePageAction({ value: 'SelectAllLocationsPage' });
      this.$emit('navigateTo', 'SelectDateTimePage', { 
          pageName:'Select Reservation Date and Time'
      });
    },
  },
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['navToSelectAllLocationsPage']),
    ...mapGetters('selectedService', ['selectedServiceTypeId', 'selectedServiceTypeId2']),
  },
  async mounted() {
    //Get all locations with selected service type//
    const typeId = this.selectedServiceTypeId;
    const typeId2 = this.selectedServiceTypeId2;
    const locations = await this.getLocationsWithServiceType({serviceTypeId:typeId, serviceTypeId2:typeId2});
    console.log(locations);
    this.locations = locations;
  }
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
